<div class="text-center" *ngIf="params">
    <i *ngIf="complete" class="fa-solid fa-circle-check fa-fw text-custom-success"></i>
    <i *ngIf="!complete" class="fa-solid fa-circle-xmark fa-fw text-custom-danger"></i>
</div>